import { render, staticRenderFns } from "./pemilu2024.vue?vue&type=template&id=5e860012&scoped=true&"
import script from "./pemilu2024.vue?vue&type=script&lang=js&"
export * from "./pemilu2024.vue?vue&type=script&lang=js&"
import style0 from "./pemilu2024.vue?vue&type=style&index=0&id=5e860012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e860012",
  null
  
)

export default component.exports